import Layout from "@/layout";
export default {
  path: "StoreCommodity",
  component: () => import("@/views/AppMain/index"),
  name: "StoreCommodity",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "门店商品管理",
    keepAlive: false,
    icon: "1011",
    activeIcon: "1010"
  },
  children: [
    {
      hidden: false,
      path: "StoreCommodityManagement",
      component: () =>
        import("@/views/HeadOfficeManagement/StoreCommodity/StoreCommodity"),
      name: "StoreCommodityManagement",
      meta: {
        title: "商城商品管理",
        keepAlive: true
      }
    },
    {
      hidden: true,
      path: "StoreCommodityEdit",
      component: () =>
        import("@/views/HeadOfficeManagement/StoreCommodity/StoreCommodityDetail"),
      name: "StoreManagementAdd",
      meta: {
        title: "编辑",
        keepAlive: false,
        activeMenu:"/HeadOfficeManagement/StoreCommodity/StoreCommodityManagement"
      }
    },
    {
      hidden: true,
      path: "StoreCommodityPreSale",
      component: () => import("@/views/HeadOfficeManagement/StoreCommodity/StoreCommodityPreSale"),
      name: "StoreCommodityPreSale",
      meta: {
        title: "预售商品管理",
        keepAlive: true,
      }
    },
    {
      hidden: true,
      path: "StoreCommodityPreSaleAdd",
      component: () => import("@/views/HeadOfficeManagement/StoreCommodity/StoreCommodityPreSaleAdd"),
      name: "StoreCommodityPreSaleAdd",
      meta: {
        title: "预售商品添加/编辑",
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/StoreCommodity/StoreCommodityPreSale'
      }
    },
    {
      hidden: true,
      path: "AddPriceAdjustment",
      component: () => import("@/views/HeadOfficeManagement/StoreCommodity/AddPriceAdjustment"),
      name: "AddPriceAdjustment",
      meta: {
        title: "商品调价新增/编辑",
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/StoreCommodity/GoodsPriceAdjustment'
      }
    },
    {
      hidden: true,
      path: "GoodsPriceAdjustment",
      component: () => import("@/views/HeadOfficeManagement/StoreCommodity/GoodsPriceAdjustment"),
      name: "GoodsPriceAdjustment",
      meta: {
        title: "商品调价",
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/StoreCommodity/GoodsPriceAdjustment'
      }
    },
    {
      hidden: false,
      path: "CommodityRecommend",
      component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityRecommend"),
      name: "CommodityRecommend",
      meta: {
        title: "商城推荐商品",
        keepAlive: true,
      }
    },
    {
      hidden: true,
      path: "CommodityRecommendAdd",
      component: () => import("@/views/HeadOfficeManagement/Commodity/CommodityRecommendAdd"),
      name: "CommodityRecommendAdd",
      meta: {
        title: "添加推荐商品",
        keepAlive: false,
        activeMenu: '/HeadOfficeManagement/Commodity/CommodityRecommend'
      }
    },
  ]
};
